import { IS_APP_PRODUCTION } from './app.config';

// Use Vite environment variables for Sentry DSN URLs
const SENTRY_DSN = 'https://08bac5de60ad8127a1107515e723c103@sentry.monit.nolimit.id/16';
const SENTRY_DSN_DEV = 'https://0f2786abbd3c9d68e2f0c896ffd48474@sentry.monit.nolimit.id/17';

export const SENTRY_RELEASE = import.meta.env.VITE_APP_VERSION;
export const SENTRY_DSN_URL = IS_APP_PRODUCTION ? SENTRY_DSN : SENTRY_DSN_DEV;
